import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import Incidence from '../materialreception/Incidence'

const MainMaterialReceptionIncidence = () => {
  const { t_ } = useSmartTranslation()

  const componentsInfo = [
    {
      title: t_('Incidence'),
      component: <Incidence />
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainMaterialReceptionIncidence
